import type React from 'react';
import { useState } from 'react';

import * as styles from './styles';
import type { ChecklistFormProps } from './formProps';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useFormikContext } from 'formik';

import { ChecklistFieldType } from '@cobliteam/api-lib';

import { DropdownMenu, type DropdownOption, RuleIconCb } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import { AddRounded, ArrowDropDownRounded, CheckCircleRounded, RadioButtonCheckedRounded } from '@mui/icons-material';
import NotesRoundedIcon from '@mui/icons-material/NotesRounded';

export const checklistItemDropdownMenuOptions = [
  {
    key: ChecklistFieldType.TEXT,
    value: 'Campo de texto',
    icon: <NotesRoundedIcon />,
  },
  {
    key: ChecklistFieldType.CHECK,
    value: 'Marcar como feito',
    icon: <CheckCircleRounded />,
  },
  {
    key: ChecklistFieldType.MULTI_SELECT,
    value: 'Múltipla escolha',
    icon: <RuleIconCb />,
  },
  {
    key: ChecklistFieldType.SINGLE_SELECT,
    value: 'Seleção única',
    icon: <RadioButtonCheckedRounded />,
  },
];

const checklistIcon = {
  [ChecklistFieldType.CHECK]: CheckCircleRounded,
  [ChecklistFieldType.TEXT]: NotesRoundedIcon,
  [ChecklistFieldType.MULTI_SELECT]: RuleIconCb,
  [ChecklistFieldType.SINGLE_SELECT]: RadioButtonCheckedRounded,
};

export interface ChecklistItemDropdownMenuProps {
  onClick: (option: DropdownOption<ChecklistFieldType>) => void;
  index?: number;
}

const getButtonClassName = (isOpen: boolean, index?: number) => {
  if (index !== undefined) {
    return styles.dropdownMenuButton(isOpen);
  }

  if (isOpen) {
    return styles.newChecklistItem;
  }

  return '';
};

const ChecklistItemDropdownMenu: React.FC<ChecklistItemDropdownMenuProps> = ({ onClick, index }) => {
  const { values } = useFormikContext<ChecklistFormProps>();
  const [isOpen, setIsOpen] = useState(false);
  const buttonClassName = getButtonClassName(isOpen, index);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleClick = (option: DropdownOption<ChecklistFieldType>) => {
    handleClose();
    onClick(option);
  };

  const renderDropdownButtonChildren = () => {
    if (index !== undefined) {
      const checklistItemType = values.checklistItems[index].type;
      const ChecklistIcon = checklistIcon[checklistItemType];

      return (
        <Button variant='ghost' onClick={handleOpen}>
          <ChecklistIcon />
          <ArrowDropDownRounded />
        </Button>
      );
    }

    return (
      <Button variant='ghost' startIcon={<AddRounded />} onClick={handleOpen}>
        Adicionar item
      </Button>
    );
  };

  return (
    <DropdownMenu options={checklistItemDropdownMenuOptions} onClick={handleClick} divider={false} className={styles.dropdownMenu}>
      <ClickAwayListener onClickAway={handleClose}>
        <div className={buttonClassName}>{renderDropdownButtonChildren()}</div>
      </ClickAwayListener>
    </DropdownMenu>
  );
};

export default ChecklistItemDropdownMenu;
